import React from "react";
import Chartseries from "../../../common/data/chartseries";
import ReactApexChart from "react-apexcharts";

const Basicarea = () => {
  const series = [
    {
      name: "Diferença de Valor Negociado por Mês",
      data: [153.48, 127.61, 108.85, 78.74, 67.48, 49, 45.76, 14.34],
    },
  ];

  var options = {
    chart: {
      zoom: {
        enabled: !1,
      },
      toolbar: {
        show: false, // Disable the toolbar
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return val + " Mil";
      },
      style: {
        colors: ["#fff"], // Set text color
      },
    },
    stroke: {
      curve: "straight",
    },
    labels: [
      "Abr",
      "Mar",
      "Mai",
      "Jan",
      "Nov",
      "Fev",
      "Out",
      "Jun",
      "Ago",
      "Jul",
      "Set",
      "Dez",
    ],
    xaxis: {
      type: "category",
    },
    yaxis: {
      show: false,
    },
    legend: {
      horizontalAlign: "left",
    },
    colors: ["#038edc"],
  };

  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={350}
      />
    </React.Fragment>
  );
};

export default Basicarea;
